import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Konkurrent = lazy(() => import("@/pages/info/Konkurrent"));

export const Route = createFileRoute("/elbyte")({
  head: () => seoHead("/elbyte", { description: "Compricer är en av Sveriges största jämförelsesajter inom el, försäkring och bolån. Här går vi igenom hur tjänsten fungerar – och hur en jämförelse hos oss skiljer sig." }),
  component: () => <Konkurrent />,
});
